import { Routes, Route } from "react-router-dom";
import {
  COMPANY_SETTINGS,
  TEMPLATES,
  SHIFT_SETTING,
  PART_SETTING,
  STAFF_SETTING,
  BREAKDOWN_SETTINGS,
  PRODUCTION_COMPONENT,
  NOTIFICATION_SETTINGS,
  COMPANY_TEMPLATES,
} from "../constants/routes";
import TemplateScreen from "../screens/TemplateScreen";

import CompanySettingsScreen from "../screens/CompanySettingsScreen";
import PartSettingScreen from "../screens/PartSettingScreen";
import ShiftSettingScreen from "../screens/ShiftSettingScreen";

import StaffSettingScreen from "../screens/staffSettingScreen";
import BreakdownSettingScreen from "../screens/BreakdownSettingScreen";
import ProductionComponentScreen from "../screens/ProductionComponentScreen";
import NotificationSettingScreen from "../screens/NotificationSetting";
import TemplateCompanyAdminScreen from "../screens/TemplateCompanyAdminScreen";
const SettingRouter = () => {
  return (
    <Routes>
      <Route path={TEMPLATES} element={<TemplateScreen />} />
      <Route path={COMPANY_TEMPLATES} element={<TemplateCompanyAdminScreen/>}/>
      <Route path={COMPANY_SETTINGS} element={<CompanySettingsScreen />} />
      <Route path={SHIFT_SETTING} element={<ShiftSettingScreen />} />
      <Route path={PART_SETTING} element={<PartSettingScreen />} />
      <Route path={STAFF_SETTING} element={<StaffSettingScreen />} />
      <Route path={BREAKDOWN_SETTINGS} element={<BreakdownSettingScreen />} />
      <Route path={PRODUCTION_COMPONENT} element={<ProductionComponentScreen/>} />
      <Route path={NOTIFICATION_SETTINGS} element={<NotificationSettingScreen/>} />
    </Routes>
  );
};
export default SettingRouter;
